// extracted by mini-css-extract-plugin
export default {"Loading12p":"A3FD1","arrows":"eddxi","caption":"aLCfV","skeleton-progress":"PJIki"};